<template>
  <wd-popup
    v-model="loginModalVisible"
    position="bottom"
    custom-class="mb-58px rounded-2 p-2 w-355px h-239px  mx-auto box-border"
    lock-scroll
    closable
  >
    <view class="center flex-col pt-30px px-4">
      <view class="text-lg font-bold mb-26px">{{ $t('liJiDengLu') }}</view>
      <wd-button
        block
        custom-class="w-full !h-47px mb-2 !bg-#76c381"
        @click="handleLogin('weixin')"
      >
        <view class="flex items-center">
          <view class="iconfont icon-weixin mr-3"></view>
          {{ $t('weiXinDengLu') }}
        </view>
      </wd-button>
      <wd-button block custom-class="w-full !h-47px mb-4" @click="handleLogin('phone')">
        <view class="flex items-center ml-3">
          <view class="iconfont icon-phone mr-3"></view>
          {{ $t('shouJiHaoDengLu') }}
        </view>
      </wd-button>

      <view>
        <wd-checkbox ref="checkboxRef" v-model="isAgree" :class="shake ? 'animate-shake' : ''">
          <view class="!text-xs !text-gray">
            {{ $t('woYiYueDuBingTongYi') }}
            <text class="text-brand">{{ $t('yongHuFuWuXieYi') }}</text>
            {{ $t('he') }}
            <text class="text-brand">{{ $t('yinSiXieYi') }}</text>
          </view>
        </wd-checkbox>
      </view>
    </view>
  </wd-popup>
</template>

<script lang="ts" setup>
import { useStorage } from '@/hooks/useStorage'
import { useUserStore } from '@/store'
import { goLogin } from '@/utils'

const { loginModalVisible } = useUserStore()
const isAgree = useStorage('isAgree', false)

const shake = ref(false)

const handleLogin = (type: 'weixin' | 'phone') => {
  if (!isAgree.value) {
    shake.value = true
    setTimeout(() => {
      shake.value = false
    }, 100)
    return
  }
  goLogin({
    params: { type },
  })
}
</script>

<style lang="scss" scoped>
//
</style>
